import { render, staticRenderFns } from "./Gameover.vue?vue&type=template&id=d2c4731a&scoped=true&"
import script from "./Gameover.vue?vue&type=script&lang=js&"
export * from "./Gameover.vue?vue&type=script&lang=js&"
import style0 from "./Gameover.vue?vue&type=style&index=0&id=d2c4731a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c4731a",
  null
  
)

export default component.exports